import type {ButtonProps} from '@chakra-ui/button';
import {Button as BaseButton} from '@chakra-ui/button';
import {omitThemingProps} from '@chakra-ui/system';

import {useButtonStyleConfig} from './theme';

type Props = ButtonProps & {
  colorScheme?: 'danger' | 'warning';
};

export const Button = (props: Props) => {
  const propsWithoutTheming = omitThemingProps(props);
  const __css = useButtonStyleConfig(props);
  return <BaseButton __css={__css} {...propsWithoutTheming} />;
};

export type {ButtonProps};
